import type {
  EntityAction,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestReferFriend = (
  payload: any,
  actions,
): EntityAction => ({
  type: actionTypes.REQUEST_REFER_FRIEND,
  payload,
  callbacks: actions,
});

export const requestSearchQuery = (
  params: any,
  tabName?: string,
): EntityAction => ({
  type: actionTypes.REQUEST_SEARCH_QUERY,
  params,
  tabName,
});

export const requestAddToLibrary = ({
  entityId,
  folderId,
  resourceType,
  callbacks,
}): EntityAction => ({
  type: actionTypes.REQUEST_ADD_TO_LIBRARY,
  entityId,
  folderId,
  resourceType,
  callbacks,
});
